import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const initialState = {
    notification:{},
    error:'',
    status:'idle',
    isNotificationBedge:false
};

export const fetchNotification = createAsyncThunk('common/fetchNotification', async (all) => {
    let accessToken = localStorage.getItem('accessToken');
    let formData = new FormData();
    formData.append("Token",accessToken);
    if(all){
        formData.append("all",true);
    }
    let response = await axios.post('form/getClientNotifications',formData);
    if (response.status === 200) {
        if(response.data.error!=2){
            return response.data;
        }else{
            removeLocalStorage();
            window.location.href = "/";
        }
    }else{
        throw new Error(response.statusText)
    }
});

export const fetchCurrentReport = createAsyncThunk('common/fetchCurrentReport', async () => {
    let accessToken = localStorage.getItem('accessToken');
    let formData = new FormData();
    formData.append("Token",accessToken);

    let response = await axios.post('form/getCurrentCreditReportPDF',formData);
    if (response.status === 200) {
        if(response.data.error!=2){
            return response.data;
        }else{
            removeLocalStorage();
            window.location.href = "/";
        }
    }else{
        throw new Error(response.statusText)
    }
});

export const createDisputeLatter = createAsyncThunk('common/createDisputeLatter', async (all) => {
    let accessToken = localStorage.getItem('accessToken');
    let formData = new FormData();
    formData.append("Token",accessToken);
    let response = await axios.post('form/disputePlanCheckout',formData);
    if (response.status === 200) {
        if(response.data.error!=2){
            return response.data;
        }else{
            removeLocalStorage();
            window.location.href = "/";
        }
    }else{
        throw new Error(response.statusText)
    }
});

export const callUserActvity = createAsyncThunk('common/createDisputeLatter', async (event) => {
    let accessToken = localStorage.getItem('accessToken');
    let formData = new FormData();
    formData.append("Token",accessToken);
    formData.append("event_log",event);
    let response = await axios.post('form/makeActivityLog',formData);
    if (response.status === 200) {
        if(response.data.error!=2){
            return response.data;
        }else{
            removeLocalStorage();
            window.location.href = "/";
        }
    }else{
        throw new Error(response.statusText)
    }
});
export const setReportAuditSelection = createAsyncThunk('common/setReportAuditSelection', async (selection) => {
    let accessToken = localStorage.getItem('accessToken');
    let formData = new FormData();
    formData.append("Token",accessToken);
    formData.append("selection",selection);
    let response = await axios.post('form/setReportAuditSelection',formData);
    if (response.status === 200) {
        if(response.data.error!==2){
            return response.data;
        }else{
            removeLocalStorage();
            window.location.href = "/";
        }
    }else{
        throw new Error(response.statusText)
    }
});



const removeLocalStorage = () => {
    localStorage.removeItem("username");
    localStorage.removeItem("isAdmin");
    localStorage.removeItem("company_id");
    localStorage.removeItem("company_logo");
    localStorage.removeItem("accessToken");
}

const CommonSlice = createSlice({
    name:'common',
    initialState,
    reducers:{
        blankFetchNotification:(state)=>{
            state.notification = {};
            state.status = "idle";
        },
        setNotifcationBedge:(state,action)=>{
            state.isNotificationBedge = action.payload;
        }
    },
    extraReducers:(builder) => {
        builder.addCase(fetchNotification.pending, (state)=>{
            state.status = 'loading';
        })
        builder.addCase(fetchNotification.fulfilled,(state,action)=>{
            state.status = 'succeeded';
            state.notification = action.payload;
            state.error = '';
        })
        builder.addCase(fetchNotification.rejected,(state,action)=>{
            state.status = 'failed';
            state.notification = {};
            state.error = action.error.message;
        })
    }
})

export const {blankFetchNotification,setNotifcationBedge} = CommonSlice.actions;

export default CommonSlice.reducer;